import { render, staticRenderFns } from "./FinancialsTab.vue?vue&type=template&id=7640243a"
import script from "./FinancialsTab.vue?vue&type=script&lang=js"
export * from "./FinancialsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports